import { render, staticRenderFns } from "./FoodTariffs.vue?vue&type=template&id=25fe2b73&scoped=true"
import script from "./FoodTariffs.vue?vue&type=script&lang=js"
export * from "./FoodTariffs.vue?vue&type=script&lang=js"
import style0 from "./FoodTariffs.vue?vue&type=style&index=0&id=25fe2b73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fe2b73",
  null
  
)

export default component.exports